import React from 'react';
import {} from 'components/hintTypes/EmailAlreadyInvitedHint/EmailAlreadyInvitedHint.types';
import { EmailAlreadyInvitedHintText } from 'components/hintTypes/EmailAlreadyInvitedHint/EmailAlreadyInvitedHintText';
import { textHelpers } from 'components/hintTypes/helpers';
export const EmailAlreadyInvitedError = ({ member, onNavigate }) => (React.createElement(React.Fragment, null,
    textHelpers.getEmailAlreadyInvitedHintTitle(member),
    " ",
    React.createElement(EmailAlreadyInvitedHintText, { onNavigate: onNavigate })));
